/**
 * Безопасная работа с localStorage: в приватном режиме, при запрете сайта или в превью
 * хранилище может бросать исключения — интерфейс должен работать и без него.
 * В хранилище — только удобства пользователя (язык, тема, последняя клиника), никаких
 * токенов и персональных данных.
 */
export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    /* хранилище недоступно — настройка просто не запомнится */
  }
}

export const STORAGE_KEYS = {
  locale: 'dodoc:locale',
  theme: 'dodoc:theme',
  lastClinic: (userId: string) => `dodoc:last-clinic:${userId}`,
  lastActivity: 'dodoc:last-activity',
  sessionLocked: 'dodoc:session-locked',
  sessionEnded: 'dodoc:session-ended',
  /** На этом устройстве задан PIN разблокировки (только признак «да/нет», не сам PIN). */
  pinEnabled: 'dodoc:pin-enabled',
} as const;
